<div class="d-flex align-items-start">
  <div class="col-5 asset-card-content-title">{{ attributeValue.name }}</div>
  <div class="col-7 asset-card-content-value">
    <select
      *ngIf="isSingle; else multipleSelection"
      class="form-select edit-input"
      [class.is-invalid]="!!error"
      [class.is-placeholder]="!selectedIds.length"
      [ngModel]="selectedIds[0] ?? null"
      (ngModelChange)="onSingleChange($event)"
    >
      <option [ngValue]="null" disabled hidden>{{ 'COMMON.SELECT' | translate }}</option>
      <option *ngFor="let option of options" [ngValue]="option.id">{{ option.value }}</option>
    </select>
    <ng-template #multipleSelection>
      <div *ngFor="let option of options" class="form-check form-check-reverse">
        <input
          type="checkbox"
          class="form-check-input"
          [id]="'dropdown_option_' + option.id"
          [checked]="selectedIds.includes(option.id)"
          (change)="onToggle(option.id)"
        />
        <label class="form-check-label" [for]="'dropdown_option_' + option.id">{{ option.value }}</label>
      </div>
    </ng-template>
    <div *ngIf="error" class="invalid-feedback d-block">
      {{ error.key | translate: error.params }}
    </div>
  </div>
</div>
